/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, OnInit, inject} from '@angular/core';
import {ModalService} from '@siemens/ix-angular';
import {Location} from '@angular/common';
import {AbstractFormWrapper} from '../../../../models/battery/abstract-form-wrapper';
import {FormPurpose} from '../../../../models/FormCategory';
import {MasterChildStringEnum} from '../../../../models/Passport';

@Component({
  selector: 'app-create-battery-pass',
  templateUrl: '../edit-battery-pass/edit-battery-pass.component.html',
  styleUrl: '../edit-battery-pass/edit-battery-pass.component.scss',
  standalone: false,
})
export class CreateBatteryPassComponent
  extends AbstractFormWrapper
  implements OnInit
{
  override readonly modalService: ModalService;
  readonly location = inject(Location);

  override purpose: FormPurpose = 'create';

  constructor() {
    const modalService = inject(ModalService);

    super();

    this.modalService = modalService;
  }

  override async afterNgOnInit() {
    if (!this.passportId) {
      this.loading = true;
      const queryParams = this.route.snapshot.queryParams;
      this.masterChildFlag = queryParams['type'] ?? MasterChildStringEnum.CHILD;
      const schemaDTO = await this.loadSchema(queryParams['schemaId']);
      this.schema = schemaDTO.data;
      this.isMasterPassport =
        (this.masterChildFlag || MasterChildStringEnum.CHILD) ===
        MasterChildStringEnum.MASTER;
      this.passportService
        .create(
          this.masterChildFlag || MasterChildStringEnum.CHILD,
          this.schema.id,
        )
        .then(async (passport) => {
          this.passportId = passport.id;
          if (this.schema.type === 'battery') {
            passport.data.generalProductInformation =
              passport.data.generalProductInformation || {};
            passport.data.generalProductInformation = {
              batteryCategory: queryParams['category'],
            };

            // To compare, if a passport has changed, set the passport-service object
            // to the latest state of the passport
            this.passportService.passportsInEdit[this.passportId] = passport;

            await this.passportService.update(
              this.passportId,
              passport,
              undefined,
            );
          }

          this.location.replaceState('/app/add-passport/' + this.passportId);
          await this.loadBatteryPass();
          await this.loadDataProvider();
        });
    } else {
      await this.loadBatteryPass();
      await this.loadDataProvider();
    }
  }

  override async onCancelClick() {
    const instance = await this.modalService.open({
      content: this.cancelModalRef,
      centered: true,
      data: this.passDisplayName,
    });

    instance.onClose.on(async (shouldCancel) => {
      if (shouldCancel && this.passportId) {
        await this.passportService.delete(this.passportId);
      }
      await this.navigateToPassportList();
    });
  }
}
